import {Component, input, output} from '@angular/core';
import {MatIconButton} from '@angular/material/button';
import {MatCard, MatCardContent, MatCardHeader, MatCardSubtitle} from '@angular/material/card';
import {MatIcon} from '@angular/material/icon';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'pm-node-icon-chooser',
  imports: [MatIcon, MatCard, MatCardHeader, MatCardSubtitle, TranslatePipe, MatCardContent, MatIconButton],
  templateUrl: './node-icon-chooser.component.html',
  styleUrl: './node-icon-chooser.component.scss',
})
export class NodeIconChooserComponent {
  protected icons = [
    null,
    'account_tree',
    'add_road',
    'assignment_add',
    'calendar_month',
    'campaign',
    'cloud',
    'code',
    'construction',
    'contract_edit',
    'conveyor_belt',
    'corporate_fare',
    'delivery_truck_speed',
    'deployed_code',
    'developer_board',
    'emergency',
    'flowchart',
    'foundation',
    'groups',
    'health_cross',
    'list_alt',
    'manage_accounts',
    'order_approve',
    'outpatient',
    'partner_exchange',
    'person_heart',
    'planner_review',
    'rule',
    'rule_settings',
    'settings_overscan',
    'shopping_bag_speed',
    'source_environment',
    'storefront',
    'supervised_user_circle',
    'topic',
    'supervisor_account',
    'trending_up',
    'shopping_cart',
    'location_on',
    'compost',
    'precision_manufacturing',
    'auto_towing',
    'local_shipping',
    'car_repair',
    'rv_hookup',
    'front_loader',
    'forklift',
    'delivery_truck_bolt',
  ];

  processIcon = input.required<string | null>();
  iconChanged = output<string|null>();
  protected iconClicked(icon: string | null) {
    this.iconChanged.emit(icon);
  }
}
